import React from "react";
import CountryBreakdown, { CountrySplit } from "./CountryBreakdown";
import CountryDailyHeatmap, { CountryDailyRow } from "./CountryDailyHeatmap";

/**
 * The "By country" tab: ranked bars (magnitude + share + combined total) over
 * a daily heatmap (when each country was present). Same numbers, two
 * questions. Shared by the single-area and project dashboards.
 */
const CountryView: React.FC<{
  loading: boolean;
  notEnabled: boolean;
  error: string | null;
  days: string[];
  rows: CountryDailyRow[];
  split: CountrySplit | null;
  rangeLabel: string;
}> = ({ loading, notEnabled, error, days, rows, split, rangeLabel }) => (
  <>
    <CountryBreakdown
      loading={loading}
      notEnabled={notEnabled}
      error={error}
      split={split}
      subtitle={`average present per day · ${rangeLabel}`}
      totalLabel="Combined average present"
    />
    {!loading && !notEnabled && !error && split && (
      <div className="mt-6">
        <CountryDailyHeatmap
          loading={false}
          notEnabled={false}
          error={null}
          days={days}
          rows={rows}
          rangeLabel={rangeLabel}
        />
      </div>
    )}
  </>
);

export default CountryView;
